module.exports = __webpack_public_path__ + "img/cert21.8f0f6796.png";